import { createContext } from 'preact';

export const FilterContext = createContext();
